import { unwrapResult } from '@reduxjs/toolkit'
import { Col, Table } from 'antd'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import { EditableList } from '../../../../compnents/list/EditableList'

import { ThemeContext } from '../../../../theme/ThemeContext'
import { Columns } from './Columuns'
import { Query } from './Query'
import styles from './order.module.css'
import { useHistory, useLocation } from 'react-router-dom'
import { getReplaceMakeOrderAmount, getreplaceMakeOrderList } from '../../StatisticSlice'
import { CellParams } from '../../../../models/StatisticAnalysis'
import { ReplaceMakeOrderAmount } from '../../../../services/StatisticAnalysis'


// 代煎订单
export const ReplaceMakeOrder = (): ReactElement => {
  const theme = useContext(ThemeContext)

  const history = useHistory()

  const location: any = useLocation()

  const dispatch = useDispatch<RootDispatch>()

  const [data, setData] = useState<any>([])

  const [total, setTotal] = useState(0)

  const [params, setParams] = useState<any>({
    current: location?.state?.current || 1,
    size: 10,
  })
  const [cell, setCell] = useState<CellParams>({})

  useEffect(() => {
    dispatch(
      getreplaceMakeOrderList({
        ...params,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {

        setTotal(res.total)
        setData(res.records)
      })

    dispatch(getReplaceMakeOrderAmount({ ...params })).then(unwrapResult).then((res: any) => {
      setCell({
        name: '合计行',
        moneySum: res.recipeMoney > 0 ? res.recipeMoney : 0,
        drugMoneySum: res.prescriptionMoney > 0 ? res.prescriptionMoney : 0
      })
    })
  }, [params])

  return (
    <Col
      style={{
        height: 'calc(100% - 20px) ',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Col
        style={{
          flex: 1,
          overflow: 'hidden',
          backgroundColor: theme.pn,
          marginTop: 10,
          borderRadius: 10,
          padding: '10px 15px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Query
          onValueChange={(v) => {
            setParams({
              ...params,
              ...v,
            })
          }}
        />
        <EditableList
          page={{
            items: data,
            current: params.current || 1,
            size: params.size || 10,
            total,
          }}
          summary={() => (
            <Table.Summary fixed>
              <Table.Summary.Row className={styles.total}>
                <Table.Summary.Cell index={0}>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1} align='center'>
                  {cell.name}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2}></Table.Summary.Cell>
                <Table.Summary.Cell index={3} align='center'>

                </Table.Summary.Cell>
                <Table.Summary.Cell index={4} align='center'>
                  {cell.moneySum}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={5} >{cell.drugMoneySum}</Table.Summary.Cell>
                <Table.Summary.Cell index={6}>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={7}>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={8}>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={9}>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={10}>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={11}>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={12}>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          )}
          style={{ color: theme.tc3 }}
          className={styles.table}
          columns={Columns((params.size || 10) * ((params.current || 1) - 1))}
          onChangePage={(current: number, size?: number) => {
            setParams({
              ...params,
              current: current,
              size: size || 10,
            })
          }}
          onRow={(t) => ({
            onDoubleClick: () => {
              history.replace({
                pathname: '/admin/replaceMakeCenter/orderDetail',
                state: {
                  id: t.billId,
                  current: params.current,
                },
              })
            },
          })}
        />
      </Col>
    </Col>
  )
}
